import React, { useMemo, useRef } from 'react';
import Select from 'react-select';

type Item = string;

type Props = {
  items: Item[];
  setSelected: (selected: number) => void;
  selected?: number;
  placeholder?: string;
};

const SearchableSelector = ({ items, setSelected, selected = 0, placeholder }: Props) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  const options = useMemo(() => items.map((label, idx) => ({ label, value: idx })), [items]);

  const value = useMemo(() => {
    if (selected == null || selected < 0 || selected >= options.length) return null as any;
    return options[selected];
  }, [options, selected]);

  return (
    <div className="selector" ref={containerRef}>
      <Select
        classNamePrefix="searchable-selector"
        options={options}
        value={value}
        onChange={(opt: any) => setSelected(opt?.value)}
        isSearchable
        isClearable={false}
        menuPosition="fixed"
        menuPortalTarget={containerRef.current}
        placeholder={placeholder ?? 'Select position...'}
      />
    </div>
  );
};

export default SearchableSelector;
